
























































import { Component, Watch, Vue } from 'vue-property-decorator'
import { hasOwnProp, isArray, capitalize } from '@/utils'
import { Load, cloner, } from '@/units'
import VForm from './helpers/views/Form.vue'
import CForm from '@/components/Form/index.vue'
import Obs from '@/form'
import './style.less'

@Component({
  components: {
    CForm,
    VForm
  }
})

export default class Users extends Vue {
  constructor () {
    super()

    console.info('📦 [Users] componentDidMount....')
  }

  // __DATA
  private taps: any = [
    { param: 'accounts', label: 'account' },
    { param: 'permissions', label: 'permission' },
    { param: 'views', label: 'view' },
  ]
  private model: any = {}
  private mode: any = new Obs({
    open: false,
    type: 'add',
    data: undefined
  })

  // __CREATED
  public async created () {
    Load(this, true)

    await this.$store.dispatch('APP.USERS/callAcc')
    Load(this, false)
  }

  // __METHODS
  private config () {
    const config: any = require('./config.json')
    this.model = cloner(config)
  }

  private onOpen (): void {
    this.config()
    this.mode.set({ open: true, type: 'add', data: this.def.field })
  }

  private onClose (): void {
    this.config()
    this.mode.reset()
  }

  private onEvents (val: any): void {
    if (val.type === 'remove') {
      this.onRemove(val.data)
    } else {
      this.config()
      this.model.field[this.paramName] = cloner(val.data)
      
      switch (this.paramName) {
        case 'accounts':
          const form: any = this.model.form[this.paramName]
          for (const field of form) {
            if (field.type === 'password') {
              field.required = false
              field.valid = ''
            }
            if (field.type === 'confirmed') {
              field.required = false
            }
          }
          break;
      }

      this.mode.set({ open: true, type: val.type, data: val.data })
    }
  }

  /**
   * For customForm submit|save
   */
  private async onTouch (val: any) {
    Load(this, true)

    const is: any = (s: string): boolean => (s === this.mode.type)
    const handle: any = {
      method  : is('add')
        ? 'POST'
        : is('edit')
          ? 'PATCH'
          : is('remove')
            ? 'DELETE'
            : 'GET',
      body    : val,
      mutation: this.paramName
    }

    switch (this.paramName) {
      case 'accounts':
        handle.get = '/user'
        handle.dispatch = 'callAcc'
        break;

      case 'permissions':
        handle.get = '/permission'
        handle.dispatch = 'callPer'
        break;

      case 'views':
        handle.get = '/view'
        handle.dispatch = 'callVie'
        break;
    }

    handle.path = `${handle.get}/${ is('add') ? 'create' : val.id}`

    const response = await this.$store.dispatch('APP.USERS/allFetch', handle)
    if (response) {
      this.onClose()
    } else {
      alert('Something went wrong!!')
    }

    Load(this, false)
  }

  private async onRemove (param: any) {
    Load(this, true)
    const handle: any = {
      method  : 'POST',
      body    : { id: param.id, status: 0 },
      mutation: this.paramName
    }

    switch (this.paramName) {
      case 'permissions':
        handle.get = '/permission'
        handle.dispatch = 'callPer'
        break;

      case 'views':
        handle.get = '/view'
        handle.dispatch = 'callVie'
        break;
    }

    handle.path = `${handle.get}/set/active`

    const res = await this.$store.dispatch('APP.USERS/allFetch', handle)
    if (!res) alert('Something went wrong!!')

    Load(this, false)
  }

  // __COMPUTED
  private get paramName (): string {
    const { name }: any = this.$route.params
    return name || ''
  }

  private get modalTitle (): string {
    const h: any = this.taps.find((x: any) => x.param === this.paramName)
    return h.label || this.paramName
  }

  /**
   * Switch Dynamic Components when tap change
   * 
   * @return {component}
   */
  private get currentTabComponent (): any {
    const helper: string = `${capitalize(this.paramName)}.vue`
    const component: any = () => import(`./helpers/${helper}`)
    return component
  }

  /**
   * Dynamic Modal Fields.
   * 
   * @return {Array}
   */
  private get def (): any {
    const field: any = this.model.field[this.paramName]
    const form: any  = this.model.form[this.paramName]
    
    // Pull data for radioType.
    for (const elm of form) {
      if (elm.data && hasOwnProp(this.db, elm.data)) {
        elm.data = this.db[elm.data].remove('isActive', 0)
      }
    }

    return { form, field }
  }

  private get db (): any {
    const cameras: any = this.$store.getters['APP.COG/cameras']
    const store: any   = this.$store.getters['APP.USERS/all']
    
    return {
      ...store,
      cameras,
      active: [
        { id: 1, name: this.$t('enabled') },
        { id: 0, name: this.$t('disabled') }
      ],
      right: [
        { id: 1, name: 'Administrator' },
        { id: 0, name: 'Member' }
      ]
    }
  }

  // __WATCH
  @Watch('$route') watchRoute () {
    this.mode.reset()
  }
}
